export const rewardCouponReducer = (state = { loading: false }, action) => {
  switch (action.type) {

    case "GET_REWARD_COUPON_LIST_REQUEST":
      return { ...state, loading: true, rewardCoupons: null };

    case "GET_REWARD_COUPON_LIST_SUCCESS":
      return { ...state, loading: false, rewardCoupons: action.payload };

    case "GET_REWARD_COUPON_LIST_FAILED":
      return { ...state, loading: false, rewardCoupons: null, error: action.payload };

    case "GET_REWARD_COUPON_REQUEST":
      return { ...state, loading: true, rewardCoupon: null };

    case "GET_REWARD_COUPON_SUCCESS":
      return { ...state, loading: false, rewardCoupon: action.payload };

    case "GET_REWARD_COUPON_FAILED":
      return { ...state, loading: false, rewardCoupon: null, error: action.payload };

    case "ADD_NEW_REWARD_COUPON_REQUEST":
      return { ...state, loading: true };

    case "ADD_NEW_REWARD_COUPON_SUCCESS":
      return { ...state, loading: false, lastAddedRewardCoupon: action.payload.data };

    case "ADD_NEW_REWARD_COUPON_FAILED":
      return { ...state, loading: false, error: action.payload };

    case "UPDATE_REWARD_COUPON_REQUEST":
      return { ...state, loading: true };

    case "UPDATE_REWARD_COUPON_SUCCESS":
      return { ...state, loading: false, rewardCoupon: action.payload };

    case "UPDATE_REWARD_COUPON_FAILED":
      return { ...state, loading: false, error: action.payload };

    case "CHANGE_REWARD_COUPON_STATUS_REQUEST":
      return { ...state, loading: true };

    case "CHANGE_REWARD_COUPON_STATUS_SUCCESS":
      return { ...state, loading: false, rewardCoupons: action.payload };

    case "CHANGE_REWARD_COUPON_STATUS_FAILED":
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};